import { render } from "./PrimaryData.vue?vue&type=template&id=12e60db7&scoped=true"
import script from "./PrimaryData.vue?vue&type=script&lang=js"
export * from "./PrimaryData.vue?vue&type=script&lang=js"

import "./PrimaryData.vue?vue&type=style&index=0&id=12e60db7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-12e60db7"

export default script